module.exports = __webpack_public_path__ + "img/clear.1892a8fb.svg";